module.exports = __webpack_public_path__ + "static/media/4_evenement.bc95c849.jpg";